export default __webpack_public_path__ + "static/media/maths-test.5f3d0194.png";